import superagent from '@ott/superagent';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RequestError } from '../../types';
import prepareQuery from '../../helpers/prepareQuery';
import { getCardInfo } from '../cardInfo/actions';
import { convertDate } from './helpers';
import { RequestResponse, Payload } from './types';

export const upgradeCard = createAsyncThunk<
  RequestResponse,
  Payload,
  { rejectValue: RequestError }
>('virtualCard/upgradeCard/fetch', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const url = '/_virtual_cards/abb/identify';
    const params = prepareQuery();

    const data: Payload = {
      ...payload,
      documentNumber: payload.documentNumber.slice(4),
      documentSeries: payload.documentNumber.slice(0, 4),
      birthDate: convertDate(payload.birthDate),
      documentIssueDate: convertDate(payload.documentIssueDate),
    };

    const {
      body: { error, result },
    } = await superagent.post(url).query(params).send(data);

    if (error) {
      throw error;
    }

    dispatch(getCardInfo());

    return result as RequestResponse;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  }
});
